import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { LogIn, Eye, EyeOff } from 'lucide-react';
import { login, seedDatabase } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1ab805ea-4762-44e6-9a14-41ceae068a7b/artifacts/8u7v0lx3_logo.jpeg";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await login(formData);
      localStorage.setItem('ad_token', res.data.access_token);
      localStorage.setItem('ad_user', JSON.stringify(res.data.user));
      toast.success('Hyrja me sukses!');
      navigate('/admin');
    } catch (err) {
      console.error('Login error:', err);
      toast.error('Kredencialet e gabuara. Provoni përsëri.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSeed = async () => {
    try {
      const res = await seedDatabase();
      toast.success(res.data.message);
      if (res.data.admin) {
        toast.info(`Admin: ${res.data.admin.username} / ${res.data.admin.password}`);
      }
    } catch (err) {
      console.error('Seed error:', err);
      toast.error('Gabim gjatë mbushjes së databazës');
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src={LOGO_URL} 
            alt="A&D Service" 
            className="h-20 w-auto mx-auto brightness-0 invert"
          />
          <p className="text-[#71717A] mt-4">Paneli i Administrimit</p>
        </div>

        {/* Login Card */}
        <div className="bg-white p-8 rounded-sm shadow-xl">
          <h1 className="text-2xl font-bold text-[#0A0A0A] mb-2">Mirë se vini</h1>
          <p className="text-[#71717A] mb-8">Hyni në panelin e administrimit</p>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="username">Emri i përdoruesit</Label>
              <Input
                id="username"
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                required
                className="mt-2"
                placeholder="admin"
                data-testid="login-username"
              />
            </div>

            <div>
              <Label htmlFor="password">Fjalëkalimi</Label>
              <div className="relative mt-2">
                <Input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required
                  className="pr-10"
                  placeholder="••••••••"
                  data-testid="login-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#71717A] hover:text-[#0A0A0A]"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#D4B982] hover:bg-[#C5A059] text-[#0A0A0A] font-semibold"
              data-testid="login-submit"
            >
              {isLoading ? (
                'Duke hyrë...'
              ) : (
                <>
                  <LogIn size={18} className="mr-2" />
                  Hyr
                </>
              )}
            </Button>
          </form>

          {/* Seed Button (for initial setup) */}
          {/* <div className="mt-6 pt-6 border-t border-[#E4E4E7]">
            <button
              onClick={handleSeed}
              className="w-full text-sm text-[#71717A] hover:text-[#D4B982] transition-colors"
              data-testid="seed-button"
            >
              Inicializo databazën (vetëm herën e parë)
            </button>
          </div> */}
        </div>

        {/* Back to site */}
        <div className="text-center mt-6">
          <a 
            href="/" 
            className="text-[#71717A] hover:text-[#D4B982] text-sm transition-colors"
          >
            ← Kthehu në faqen kryesore
          </a>
        </div>
      </div>
    </div>
  );
}
